var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExpoIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      width: 12,
      height: 12
    },
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 11,
    height: 11,
    stroke: "#666666"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.79901 10V2.72727H8.35866V3.67188H4.89631V5.88778H8.12074V6.82884H4.89631V9.0554H8.40128V10H3.79901Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpoIcon);
export default __webpack_public_path__ + "static/media/expo_icon.912116172eb289b3e70a16c8ffa1de83.svg";
export { ForwardRef as ReactComponent };